import React, { Component } from 'react';
import BasePage from './BasePage';
import Session from '../services/session'
import Banner from '../partials/Banner';
import AddressToMapComponent from '../components/AddressToMapComponent'
import i from '../imports';
import c from '../components';
import d from '../dialogs';
import Dialog from 'material-ui/Dialog';


import { compose, withProps, lifecycle  } from "recompose";

import BreadCrumbs from '../partials/BreadCrumbs';

import {
    withState,
    withScriptjs,
    withGoogleMap,
    GoogleMap,
    Marker
} from "react-google-maps";

//import Geocode from "react-geocode";



class DialogBody extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <span>Body</span>
        )
    }
} 

class AccomodationPage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            cityValue: 0,
            accomodationTypeValue: 0,
            openDialog: false,
            latitude: 0,
            longitude: 0
        };
        
        
    }

    handleCityChange = (event, index, value) => this.setState({ cityValue: value });
    handleAccomodationTypeChange = (event, index, value) => this.setState({ accomodationTypeValue: value });

    handleOpenDialog = (event) => {
        this.setState({
            openDialog: true
        });
    }

    handleCloseDialog = (event) => {
        this.setState({
            openDialog: false
        });
    }


    render() {

        const data = this.props.data;
        const destination = Session.model.destinationPages.filter(d => d.name.toLowerCase() === data.destination.toLowerCase())[0];

        let destinations = Session.model.destinationPages.filter(f => f.name != destination.name);
        destinations = i.Utils.sortByIndex(destinations).slice(0, 6);

        return (
            <BasePage data={this.props.data}>

                <BreadCrumbs fullpath={window.location.pathname} name={data.translations[0].title} />
                <i.PureGridProvider>
                    <i.Container>
                        <i.Row>
                            <i.Col md={12} >
                            <div style={{backgroundColor: 'black', width: "400px", height:"300px",float: "right", margin: "10px 10px 10px 10px"}}>
                               
                                { this.props.data.geolocation ?
                                <AddressToMapComponent address={this.props.data.address} latitude={this.props.data.geolocation.latitude} longitude={this.props.data.geolocation.longitude} />
                                : 
                                <AddressToMapComponent address={this.props.data.address} latitude={destination.location.latitude} longitude={destination.location.longitude} />
                                }
                                {this.props.data.address}
                                </div>
                                {
                                    i.markdown(data.translations[0].text)
                                }
                                
                            </i.Col>
                        </i.Row>
                        <i.Row style={{ paddingBottom: 30 }}>
                            <i.Col xs={12} align="center">
                                <button className='button' onClick={this.handleOpenDialog}>{Session.model.accomodation.button}</button>
                                {/*<i.RaisedButton label="_REQUEST_"
                                    backgroundColor="#FF5563"
                                    labelColor="white"
                                    style={{backgroundColor: "#FF5563"}}/>*/}

                                <d.AccomodationDialog
                                    form_title={Session.model.accomodation.form_title}
                                    form_description={Session.model.accomodation.form_description}
                                    openDialog={this.state.openDialog}
                                    onClose={this.handleCloseDialog}
                                    hotel={data.translations[0].title}
                                // calcValues={}
                                />
                            </i.Col>
                        </i.Row>
                        <i.Row style={{ paddingBottom: 20 }}>
                            <i.Col>
                                {Session.model.accomodationPages.length > 0 ?
                                    <div>
                                        <h2>{`${Session.model.accomodation.other_offers} ${destination.translations[0].title}`}</h2>
                                        <c.CardsList items={Session.model.accomodationPages.filter(a => a.name != data.name && a.destination === data.destination).slice(0, 3)} urlBuilder={i.Utils.createAccomodationUrl} />
                                        <h2><i.NavLink style={{ color: "#FF5563", textDecoration: "none" }} to={i.Utils.locUrl(`accomodation/city/${destination.name}`)}>{Session.model.common.words.find_more}</i.NavLink></h2>
                                    </div>
                                    : null
                                }
                            </i.Col>
                        </i.Row>
                        <i.Row style={{paddingBottom: 20}}>
                        <i.Col>
                            {destinations.length > 0 ?
                                <div>
                                    <h2>{Session.model.common.words.other_destinations}</h2>
                                    <c.CardsList items={destinations} urlBuilder={i.Utils.createDestinationUrl} />
                                    <h2><i.NavLink style={{color: "#FF5563", textDecoration: "none"}} to={i.Utils.locUrl("destinations")}>{Session.model.common.words.find_more}</i.NavLink></h2>
                                </div>
                                : null
                            }
                        </i.Col>
                    </i.Row>
                    </i.Container>
                </i.PureGridProvider>
            </BasePage>
        );

    }

    

}



export default AccomodationPage;